import type { SortColumn } from '~/modules/common/data-grid';

type Sort = SortColumn['columnKey'];
type Order = 'asc' | 'desc';

// biome-ignore lint/suspicious/noExplicitAny: unable to infer type due to dynamic data structure
type SetSearch = (newValues: any) => void;

export const useSortColumns = (sort: Sort | undefined, order: Order | undefined, setSearch: SetSearch) => {
  let sortColumns: SortColumn[] = [];
  if (sort && order) sortColumns = [{ columnKey: sort, direction: order === 'asc' ? 'ASC' : 'DESC' }];

  const setSortColumns = (newSortColumns: SortColumn[]) => {
    if (newSortColumns.length === 0) return setSearch({ sort: undefined, order: undefined });
    setSearch({ sort: newSortColumns[0].columnKey, order: newSortColumns[0].direction === 'ASC' ? 'asc' : 'desc' });
  };

  return { sortColumns, setSortColumns };
};
